import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "pb-6 text-base leading-6 font-medium text-black" }, "Based on percentage split", -1)
const _hoisted_2 = { class: "relative w-9/12 mb-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "absolute inset-y-0 right-0 flex items-center pt-6 pr-2 text-gray-500" }, "%", -1)

import { onMounted } from "vue"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsButton from "@/components/GgmsButton.vue"
import { PlusIcon, TrashIcon } from "@heroicons/vue/outline"
import { useWorkflowStore } from "@/stores/workflow"


export default /*#__PURE__*/_defineComponent({
  __name: 'PercentageSplitComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()

function addBranch(): void {
    const currentBranches = workflowStore.branches.length

    workflowStore.branches.push({
        value: 0,
        label: `Branch ${currentBranches + 1}`,
        type: "percentage",
    })

    redistributePercentages()
}

function removeBranch(index: number): void {
    workflowStore.branches.splice(index, 1)
    workflowStore.branches = workflowStore.branches.map((branch, idx) => ({
        ...branch,
        label: `Branch ${idx + 1}`,
    }))

    if (workflowStore.branches.length > 0) {
        redistributePercentages()
    }
}

function redistributePercentages(): void {
    const branchCount = workflowStore.branches.length
    if (branchCount === 0) return

    const equalPercentage = Math.floor(100 / branchCount)
    const remainder = 100 % branchCount

    workflowStore.branches.forEach((branch, index) => {
        branch.value = equalPercentage + (index < remainder ? 1 : 0)
    })
}

function onPercentageChange(index: number): void {
    const branch = workflowStore.branches[index]
    const numValue = Number(branch.value)

    // Ensure value is within bounds
    if (numValue < 0) {
        branch.value = 0
    } else if (numValue > 100) {
        branch.value = 100
    }

    // Auto-adjust other branches proportionally
    adjustOtherBranches(index)
}

function adjustOtherBranches(changedIndex: number): void {
    const changedBranch = workflowStore.branches[changedIndex]
    const changedValue = Math.round(Number(changedBranch.value))
    changedBranch.value = changedValue // Ensure the changed value is also rounded

    const otherBranches = workflowStore.branches.filter((_, index) => index !== changedIndex)

    if (otherBranches.length === 0) return

    const remainingPercentage = 100 - changedValue
    const currentOtherTotal = otherBranches.reduce((sum, branch) => sum + Number(branch.value), 0)

    if (currentOtherTotal === 0 || remainingPercentage <= 0) {
        // Distribute remaining percentage equally among other branches
        const baseShare = Math.floor(Math.max(0, remainingPercentage) / otherBranches.length)
        const remainder = Math.max(0, remainingPercentage) % otherBranches.length

        otherBranches.forEach((branch, index) => {
            branch.value = baseShare + (index < remainder ? 1 : 0)
        })
    } else {
        // Adjust other branches proportionally
        const scaleFactor = remainingPercentage / currentOtherTotal
        let distributedTotal = 0

        otherBranches.forEach((branch, index) => {
            if (index === otherBranches.length - 1) {
                // Last branch gets whatever is left to ensure total is exactly 100
                branch.value = remainingPercentage - distributedTotal
            } else {
                branch.value = Math.round(Number(branch.value) * scaleFactor)
                distributedTotal += branch.value
            }
        })
    }
}

onMounted(() => {
    workflowStore.areButtonDisabled = false

    // Initialize with equal percentages if branches exist but have no values
    if (workflowStore.branches.length > 0) {
        const hasValidValues = workflowStore.branches.some((branch) => Number(branch.value) > 0)
        if (!hasValidValues) {
            redistributePercentages()
        }
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workflowStore).branches, (branch, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: branch.label,
        class: "flex items-center w-full gap-x-2"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(GgmsInput, {
            modelValue: branch.value,
            "onUpdate:modelValue": ($event: any) => ((branch.value) = $event),
            modelModifiers: { number: true },
            label: branch.label,
            type: "number",
            min: "0",
            max: "100",
            onInput: ($event: any) => (onPercentageChange(index))
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onInput"]),
          _hoisted_3
        ]),
        (_unref(workflowStore).branches.length > 1)
          ? (_openBlock(), _createBlock(_unref(TrashIcon), {
              key: 0,
              class: "w-5 h-5 cursor-pointer",
              onClick: ($event: any) => (removeBranch(index))
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createVNode(GgmsButton, {
      styleType: "simple",
      "icon-start": _unref(PlusIcon),
      class: "w-fit",
      classes: ['py-0 px-0 pr-2 text-primary-color-600'],
      "icon-classes": ['fill-primary-color-600'],
      onClick: addBranch
    }, {
      default: _withCtx(() => [
        _createTextVNode("Add Branch")
      ]),
      _: 1
    }, 8, ["icon-start"])
  ], 64))
}
}

})